/* eslint max-classes-per-file: 0 */

import { NotificationPage as Data, NotificationPageCollection as Collection } from '@/typings/api/NotificationPage'

import { Fabric } from '@/store/createCrudModule'
import { LkNotificationPagesAdapter } from './LkNotificationPagesAdapter'
import { Store } from 'vuex'
import { Context } from 'vuex-smart-module'
import { authStoreModule } from '@/views/Auth/store'
import { LkPublicNotificationPagesAdapter } from '@/views/LKNotificationPages/store/LkPublicNotificationPagesAdapter'


export const fabric = Fabric<Data, Collection>()

type S = LkNotificationPagesState
type G = LkNotificationPagesGetters
type M = LkNotificationPagesMutations
type A = LkNotificationPagesActions

export class LkNotificationPagesState extends fabric.State {

}

export class LkNotificationPagesGetters extends fabric.Getters<S> {
  private store!: Store<unknown>;

  private auth!: Context<typeof authStoreModule>;

  public $init(store: Store<unknown>) {
    this.store = store
    this.auth = authStoreModule.context(store)
  }

  public get authorized() {
    return this.auth.getters.authorized
  }
}

export class LkNotificationPagesMutations extends fabric.Mutations<S> {

}

export class LkNotificationPagesActions extends fabric.Actions<S, G, M, A> {
  protected readonly adapter = new LkNotificationPagesAdapter();

  protected readonly publicAdapter = new LkPublicNotificationPagesAdapter();

  protected readonly idName = 'id';

  public async getOneByUrl(params: Data) {
    const { authorized } = this.getters
    let data
    if (authorized) {
      data = await this.adapter.api.getByUrl(params.url)
    } else {
      data = await this.publicAdapter.api.getByUrl(params.url)
    }

    return data
  }
}
